import { IRoute } from "@/interfaces/Route";
import {
  faA,
  faComments,
  faBuilding,
  faBuildingWheat,
  faCalendar,
  faChartPie,
  faClockRotateLeft,
  faCodeBranch,
  faE,
  faEnvelope,
  faF,
  faM,
  faFile,
  faFileSignature,
  faList,
  faO,
  faPhone,
  faSchool,
  faUserGraduate,
  faUsersBetweenLines,
  faUsersViewfinder,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

export const PUBLIC_ROUTES = [
  "/login",
  "/forgotPassword",
  "/verificationOtp",
  "/register",
];

export const adminRoutes: IRoute = {
  label: "Administration",
  roles: ["ADMIN"],
  children: [
    { name: "Google Meet", icon: faComments, href: "/admin/google-meet", strictAdmin: true },
    {
      name: "Dashboard",
      icon: faChartPie,
      href: "/admin/dashboard",
    },
    {
      name: "Utilisateurs",
      icon: faUsersViewfinder,
      href: "/users",
    },
    {
      name: "Equipes",
      icon: faUsers,
      href: "/teams",
    },
    {
      name: "Visibilité calendrier",
      icon: faCalendar,
      href: "/calendar-visibilities",
    },
    {
      name: "Conventions signées",
      icon: faFileSignature,
      href: "/admin/signed-conventions-stats",
    },
    {
      name: "Lignes softphone",
      icon: faPhone,
      href: "/softphone-lines",
    },
  ],
};

export const configRoutes: IRoute = {
  label: "Configuration",
  roles: ["ADMIN", "CSM"],
  children: [
    {
      name: "Statuts d'entreprise",
      icon: faE,
      href: "/company-statuses",
    },
    {
      name: "Statuts de formation",
      icon: faF,
      href: "/company-course-statuses",
    },
    {
      name: "Statuts de RDV montage",
      icon: faM,
      href: "/montage-meeting-statuses",
    },
    {
      name: "Opcos",
      icon: faO,
      href: "/opcos",
    },
    {
      name: "Organismes",
      icon: faBuildingWheat,
      href: "/organizations",
    },
    {
      name: "Plaquettes",
      icon: faFile,
      href: "/plaquettes",
    },
    {
      name: "Templates d'emails",
      icon: faEnvelope,
      href: "/email-templates",
    },
    {
      name: "Sécteurs d'activité",
      icon: faA,
      href: "/activity-sectors",
    },
  ],
};

export const mySpace: IRoute = {
  label: "Mon espace",
  labelDisable: true,
  children: [
    { name: "Messagerie", icon: faComments, href: "/chat" },
    {
      name: "Calendrier commercial",
      icon: faCalendar,
      href: "/calendar",
    },
    {
      name: "Calendrier montage",
      icon: faCalendar,
      href: "/calendar-montage",
      roles: ["ADMIN", "CSM", "AE", "SDR"],
    },
    {
      name: "Tableau de bord d'appel",
      icon: faClockRotateLeft,
      href: "/call-logs",
    },
  ],
};

export const databaseRoutes: IRoute = {
  label: "Base de données",
  children: [
    {
      name: "Général",
      icon: faList,
      href: "/general",
    },
    {
      name: "Entreprises",
      icon: faBuilding,
      href: "/companies",
    },
    {
      name: "Personnes",
      icon: faUsersBetweenLines,
      href: "/people",
      roles: ["ADMIN", "AE", "CSM"],
    },
    {
      name: "Formations",
      icon: faSchool,
      href: "/courses",
    },
    {
      name: "Formateurs",
      icon: faUserGraduate,
      href: "/instructors",
      roles: ["ADMIN", "CSM"],
    },
  ],
};

export const devRoutes: IRoute = {
  label: "Developpement",
  children: [
    {
      name: "Mises à jour",
      icon: faCodeBranch,
      href: "/changelog",
    },
  ],
};

const toExport = [
  mySpace,
  adminRoutes,
  configRoutes,
  databaseRoutes,
  devRoutes,
];

export default toExport;
